import { render, staticRenderFns } from "./CodmDan.vue?vue&type=template&id=c90af1ec&scoped=true"
import script from "./CodmDan.vue?vue&type=script&lang=js"
export * from "./CodmDan.vue?vue&type=script&lang=js"
import style0 from "./CodmDan.vue?vue&type=style&index=0&id=c90af1ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90af1ec",
  null
  
)

export default component.exports